import TaskAltIcon from '@mui/icons-material/TaskAlt'
import UnpublishedIcon from '@mui/icons-material/Unpublished'
import { ListItemButton, ListItemText, ListItemIcon } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface CalendarListHeaderProps {
  isAllSelected: boolean
  onToggle: (event: React.MouseEvent<HTMLElement>) => void
}

export const CalendarListHeader: React.FC<CalendarListHeaderProps> = ({ isAllSelected, onToggle }) => {
  const { t } = useTranslation()

  return (
    <ListItemButton onClick={onToggle} aria-label={isAllSelected ? t('Select none') : t('Select all')}>
      <ListItemIcon>{isAllSelected ? <UnpublishedIcon /> : <TaskAltIcon />}</ListItemIcon>
      <ListItemText primary={isAllSelected ? t('Select none') : t('Select all')} />
    </ListItemButton>
  )
}

export default CalendarListHeader
